import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export const useDeleteIngredient = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<void, unknown, { ingredientId: string }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<void, unknown, { ingredientId: string }>({
        mutationFn: async (parameters: { ingredientId: string }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.delete(parameters.ingredientId, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
